import { SxProps, Theme } from '@mui/system';

const styles = {
  planContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '24px',
    border: '1px solid',
    borderColor: 'common.border',
    borderRadius: '8px',
    marginBottom: '24px',
    width: '100%',
  },
  chip: {
    width: 'fit-content',
    backgroundColor: 'payment.orange',
    padding: '4px 14px',
    borderRadius: '40px',
    display: 'flex',
    justifyContent: 'center',
  },
  chipLabel: {
    color: 'secondary.main',
    fontSize: 14,
  },
  planType: {
    fontWeight: '600',
    fontSize: '18px',
    color: 'grey.800',
  },
  planCost: {
    fontWeight: '600',
    fontSize: 32,
    color: 'common.grey850',
  },
  subLabel: {
    color: 'grey.500',
    fontSize: 14,
    fontWeight: '500',
  },
  caption: {
    fontWeight: '400',
  },
  componentMargin: {
    marginBottom: '4px',
  },
  radio: {
    padding: 0,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
